/**
     * @desc 查询已上架NFT作品列表
用于查询用户collection中已上架的NFT列表，包含订单信息和最高报价信息
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/item/getOnSaleItemList', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/item/getOnSaleItemList', params);
}
